"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
function mockPromise(value, success) {
  return {
    then: function then(resolve, reject) {
      if (success && !!resolve) resolve(value);else if (!success && reject) reject(value);
      return mockPromise(undefined, true);
    }
  };
}
exports.mockPromise = mockPromise;